module.exports = __webpack_public_path__ + "img/top.109657ca.png";